import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from './UI';
import { useAuth } from '../context/AuthContext';

const ROLE_COLORS = {
  ADMIN:    '#E24B4A',
  OPERATOR: '#BA7517',
  VIEWER:   '#3B6D11',
};

export default function Header({ apiOnline, lastRefresh, refreshing, onRefresh }) {
  const { user, logout, isAdmin } = useAuth();
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{
      background: 'var(--bg-dark)',
      padding: '16px 20px',
      position: 'sticky', top: 0, zIndex: 50,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 10, color: '#FAC775', fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 4, fontFamily: 'var(--font-cond)' }}>
            Bhagwati Stone Crusher · Nawada
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.02em', fontFamily: 'var(--font-cond)' }}>
            Gate Control
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 7, height: 7, borderRadius: '50%', background: apiOnline ? '#97C459' : '#E24B4A', animation: apiOnline ? 'pulse 2s infinite' : 'none' }} />

          <button onClick={onRefresh} disabled={refreshing} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: '#B4B2A9', borderRadius: 8, padding: '6px 10px', fontSize: 12, display: 'flex', alignItems: 'center', gap: 5 }}>
            {refreshing ? <Spinner size={11} color="#B4B2A9" /> : '↻'}
          </button>

          <div style={{ position: 'relative' }}>
            <button onClick={() => setShowMenu(!showMenu)} style={{ background: ROLE_COLORS[user?.role] || '#888', border: 'none', borderRadius: '50%', width: 34, height: 34, color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {user?.fullName?.[0]?.toUpperCase() || 'U'}
            </button>

            {showMenu && (
              <div style={{ position: 'absolute', top: 40, right: 0, background: '#fff', border: '1px solid var(--border)', borderRadius: 12, padding: '8px 0', minWidth: 200, boxShadow: '0 8px 30px rgba(0,0,0,0.15)', zIndex: 100 }}>
                <div style={{ padding: '10px 16px', borderBottom: '0.5px solid var(--border)' }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text-primary)' }}>{user?.fullName}</div>
                  <div style={{ fontSize: 11, marginTop: 2, color: ROLE_COLORS[user?.role], fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{user?.role}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)', marginTop: 2 }}>@{user?.username}</div>
                </div>
                <button onClick={() => { logout(); setShowMenu(false); }} style={{ width: '100%', padding: '11px 16px', background: 'none', border: 'none', textAlign: 'left', fontSize: 13, color: '#E24B4A', fontWeight: 600, cursor: 'pointer' }}>
                  Sign Out
                </button>
                <a href="/labeling.html" style={{ display: 'block', padding: '11px 16px', textDecoration: 'none', color: 'var(--text-primary)', fontWeight: 500 }}>Open labeling tool</a>
                {isAdmin && (
                  <button onClick={() => { setShowMenu(false); navigate('/reject-vehicle'); }} style={{ width: '100%', padding: '11px 16px', background: 'none', border: 'none', textAlign: 'left', fontSize: 13, color: 'var(--text-primary)', fontWeight: 500, cursor: 'pointer' }}>
                    Reject vehicle
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {lastRefresh && (
        <div style={{ fontSize: 10, color: '#444441', marginTop: 8 }}>
          Updated {lastRefresh.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })} · Auto-refresh 15s
        </div>
      )}
    </div>
  );
}
